import { useState, useEffect } from "react"
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contextos/AuthProvider'
import { FormasFarmaceuticas, CodigosTarifas, CodigosImpuestos, EstadosArticulos, EncApi, EncabezadoPost } from "../Comunes/Listas";
import Swal from 'sweetalert2'
import Modal from 'react-modal';
import axios from 'axios';

const FichaCatalogo = (props) => {

    const [isModalOpen, setIsModalOpen] = useState(false);

    const [searchTerm, setSearchTerm] = useState('');
    const [cabysData, setCabysData] = useState([]);
    const handleSearch = async () => {
        try {
            const response = await axios.get(`https://api.hacienda.go.cr/fe/cabys?q=${searchTerm}`);
            setCabysData(response.data.cabys);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleButtonClick = (codigo) => {
        setGestor({ ...Gestor, "CABYS": codigo });
        setIsModalOpen(false);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };
    const customStyles = {
        content: {
            top: '30%',
            left: '45%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#e7ecf0',
            borderTop: '#e09d00 solid 3px'
        },
    };

    const navigate = useNavigate();
    const { PerfilUsuario, Token } = useAuth();
    const [Gestor, setGestor] = useState({})

    const Modificar = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case 'DE_CODIGO_TARIFA':
                switch (value) {
                    case '01':
                        setGestor({ ...Gestor, [name]: value, "DE_TASA_IMP": 0 });
                        break;
                    case '02':
                        setGestor({ ...Gestor, [name]: value, "DE_TASA_IMP": 1 });
                        break;
                    case '03':
                        setGestor({ ...Gestor, [name]: value, "DE_TASA_IMP": 2 });
                        break;
                    case '04':
                        setGestor({ ...Gestor, [name]: value, "DE_TASA_IMP": 4 });
                        break;
                    case '05':
                        setGestor({ ...Gestor, [name]: value, "DE_TASA_IMP": 0 });
                        break;
                    case '06':
                        setGestor({ ...Gestor, [name]: value, "DE_TASA_IMP": 4 });
                        break;
                    case '07':
                        setGestor({ ...Gestor, [name]: value, "DE_TASA_IMP": 8 });
                        break;
                    case '08':
                        setGestor({ ...Gestor, [name]: value, "DE_TASA_IMP": 13 });
                        break;
                    case '09':
                        setGestor({ ...Gestor, [name]: value, "DE_TASA_IMP": 0.5 });
                        break;
                    case '10':
                        setGestor({ ...Gestor, [name]: value, "DE_TASA_IMP": 0 });
                        break;
                    case '11':
                        setGestor({ ...Gestor, [name]: value, "DE_TASA_IMP": 0 });
                        break;
                    default:
                }
                break;
            case 'DE_UNIDAD_MEDIDA':
                switch (value) {
                    case '0':
                    case '3':
                    case '66':
                    case '87':
                    case '88':
                    case '89':
                    case '90':
                    case '91':
                    case '92':
                    case '96':
                    case '97':
                        setGestor({ ...Gestor, [name]: value, "DE_TIPO_ARTICULO": 0 });
                        break;
                    default:
                        setGestor({ ...Gestor, [name]: value, "DE_TIPO_ARTICULO": 1 });
                }
                break;
            default:
                setGestor({ ...Gestor, [name]: value });
        }


        //console.log(props.EntidadActual);
    }

    const clicAplicaIVI = () => {
        setGestor({ ...Gestor, "DE_PRECIO_IVI": Gestor.DE_PRECIO_IVI === 'S' ? 'N' : 'S' });
    }
    function checkPrecioIVI() {
        //console.log(Gestor.DE_PRECIO_IVI)
        return <input type='checkbox' onChange={clicAplicaIVI} id='CheckAplicaServRest'
            value={Gestor.DE_PRECIO_IVI} checked={Gestor.DE_PRECIO_IVI === 'S'} />
    }

    const handleOnSubmit = async (e) => {

        if (e.which === '13') {
            e.preventDefault();
        }
        e.preventDefault();
    };
    const Salir = () => {
        navigate("/Productos/CatalogoGeneral");
    }
    const UnidadesMedida = async () => {
        const URL = 'https://SmartFeCr.com:2020/SmartContrackBack/api/Inventario/UNIDADES_MEDIDAs'
        const resp = await fetch(URL,EncApi(Token)).then(response => response.json())
        setLasUnidadesMedida(resp)
    }
    const [LasUnidadesMedida, setLasUnidadesMedida] = useState([])

    const ParametrosInicialesCarga = async (CodArt) => {

        let URL = 'https://SmartFeCr.com:2020/SmartContrackBack/api/Inventario/ObtenerUnCatalogo?IdCia=' + PerfilUsuario.IdCia + '&CodigoArt=' + CodArt

        console.log(URL);
        await fetch(URL,EncApi(Token)).then(response => response.json())
            .then(json => {
                //console.log(json);
                if (json.Codigo === 0) {
                    setGestor(json.Datos);
                }
            })
    };

    const GuadarArticulo = async () => {
        Swal.fire({
            title: '¿Seguro en guardar los datos de catálogo?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Si, de acuerdo',
            denyButtonText: `No, Cancelar`,
        }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                console.log(JSON.stringify(Gestor))
                const URL = props.EntidadActual === "" ? 'https://SmartFeCr.com:2020/SmartContrackBack/api/Inventario/NuevoCatalogo' : 'https://SmartFeCr.com:2020/SmartContrackBack/api/Inventario/ActualizarCatalogo'

                console.log(URL);

                await fetch(URL, EncabezadoPost(Token, Gestor)).then(response => response.json())
                    .then(json => {
                        console.log(json);
                        if (json.Codigo === 0) {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Catálogo Guardado',
                                showConfirmButton: false,
                                timer: 1500
                            })
                            navigate("/Productos/CatalogoGeneral");
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Alerta...',
                                text: json.Mensaje + " InnerEx " + json.Objeto

                            })
                        }
                    })
            }
        })

    }



    useEffect(() => {

        if (PerfilUsuario) {
            //console.log(Rol)
            UnidadesMedida()
            if (props.EntidadActual !== "") {
                ParametrosInicialesCarga(props.EntidadActual)
            }
            else {
                setGestor({
                    "CON_CODIGO": PerfilUsuario.IdCia,
                    "DE_CODIGO_ART": '',
                    "DE_NOMBRE_ART": '',
                    "DE_PRECIO": 0,
                    "DE_CODIGO_IMPUESTO": '01',
                    "DE_CODIGO_TARIFA": '08',
                    "DE_TASA_IMP": 13,
                    "DE_UNIDAD_MEDIDA": '0',
                    "DE_TIPO_ARTICULO": 0,
                    "DE_PRECIO_IVI": 'N',
                    "CABYS": '',
                    "ESTADO": 'ACT',
                    "RegistroMedicamento": '',
                    "FormaFarmaceutica": '00'
                })
            }

        }
        // eslint-disable-next-line
    }, [])



    if (PerfilUsuario) {
        return (<div className='main-block'>
            <div className="form" onSubmit={(e) => handleOnSubmit(e)}>
                <div className='formadoShadow'>

                    <div className='tituloPantalla'>
                        <p style={{ display: 'inline-block' }}> Detalle Catálogo Producto y Servicios</p>
                        <button className="botonCerrar" style={{ backgroundColor: '#f3f3f3', width: '50px' }} id="SalirHome" onClick={Salir} name="SalirHome"><i className="fa fa-times"></i></button>
                    </div>
                    <div className="row">
                        <div className="col-25">
                            <button id="Guardar" onClick={() => GuadarArticulo()} name="Guardar">Guardar</button>
                        </div>
                        <div className='col-75'></div>
                    </div>
                    <div className="row">

                        <div className="col-25">
                            <span className="col-form-span" >Código </span>
                            <input type="text"
                                id="DE_CODIGO_ART"
                                name="DE_CODIGO_ART"
                                autoComplete='off'
                                title="Cree su propio código para el artículo"
                                value={Gestor.DE_CODIGO_ART}
                                onChange={Modificar}></input>
                        </div>

                        <div className="col-75">
                            <span className="col-form-span" >Descripción </span>
                            <input type="text" id="DE_NOMBRE_ART" name="DE_NOMBRE_ART" autoComplete='off'
                                value={Gestor.DE_NOMBRE_ART} onChange={Modificar}></input>

                        </div>
                    </div>

                    <div className="row">
                        <div className="col-25">
                            <div className="row">
                                <div className="col-50">
                                    <span className="col-form-span" >Precio IVI </span>
                                    {checkPrecioIVI()}
                                </div>
                                <div className="col-50">
                                    <span className="col-form-span" >Precio </span>
                                    <input type="text" id="DE_PRECIO" name="DE_PRECIO" autoComplete='off' value={Gestor.DE_PRECIO} onChange={Modificar}></input>
                                </div>
                            </div>
                        </div>
                        <div className="col-25">
                            <button className="opciones-btn" onClick={() => setIsModalOpen(true)}>Cabys</button>
                            <input type="text" id="CABYS" name="CABYS" autoComplete='off' value={Gestor.CABYS} onChange={Modificar}></input>
                        </div>

                        <div className="col-25">
                            <span className="col-form-span" >Estado </span>
                            <select id="ESTADO" name="ESTADO" className="form-group" onChange={Modificar} value={Gestor.ESTADO}>
                                {EstadosArticulos.map((option, i) => (
                                    <option key={i} value={option.value}>{option.span}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-25">
                            <span className="col-form-span" >Unidad Medida </span>
                            <select id="DE_UNIDAD_MEDIDA" name="DE_UNIDAD_MEDIDA" className="form-group" onChange={Modificar} value={Gestor.DE_UNIDAD_MEDIDA}>
                                {LasUnidadesMedida.map((option, i) => (
                                    <option key={i} value={option.CODIGO}>{option.NOMBRE}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-25">
                            <span className="col-form-span" >Código Impuesto </span>
                            <select id="DE_CODIGO_IMPUESTO" name="DE_CODIGO_IMPUESTO" className="form-group" onChange={Modificar} value={Gestor.DE_CODIGO_IMPUESTO}>
                                {CodigosImpuestos.map((option, i) => (
                                    <option key={i} value={option.value}>{option.span}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-25">
                            <span className="col-form-span" >Código tarifa </span>
                            <select id="DE_CODIGO_TARIFA" name="DE_CODIGO_TARIFA" className="form-group" onChange={Modificar} value={Gestor.DE_CODIGO_TARIFA}>
                                {CodigosTarifas.map((option, i) => (
                                    <option key={i} value={option.value}>{option.span}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-25">
                            <span className="col-form-span" >Registro Medicamento</span>
                            <input type="text" id="RegistroMedicamento" name="RegistroMedicamento" autoComplete='off' value={Gestor.RegistroMedicamento} onChange={Modificar}></input>
                        </div>
                        <div className="col-25">
                            <span className="col-form-span" >Forma Farmaceutica</span>
                            <select id="FormaFarmaceutica" name="FormaFarmaceutica" className="form-group" onChange={Modificar} value={Gestor.FormaFarmaceutica}>
                                {FormasFarmaceuticas.map((option, i) => (
                                    <option key={i} value={option.value}>{option.span}</option>
                                ))}
                            </select>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-25">
                            <span className="col-form-span" >Partida Arancelaria </span>
                            <input type="text" id="PartidaArancelaria" name="PartidaArancelaria" autoComplete='off' placeholder="Solo para Bienes y de Exportación" value={Gestor.PartidaArancelaria} onChange={Modificar}></input>
                        </div>
                        <div className="col-75">

                        </div>
                    </div>

                    {isModalOpen && (
                        <Modal
                            isOpen={isModalOpen}
                            onRequestClose={closeModal}
                            ariaHideApp={false}
                            size='sm'
                            className={'mymodalSeleccionarCabys'}
                            style={customStyles}
                        >

                            <div style={{ width: '100%', overflowY: 'auto' }}>
                                <input
                                    type="text"
                                    style={{ marginTop: '10px' }}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    placeholder="Buscar CABYS"
                                />
                                <button onClick={handleSearch}>Buscar</button>
                                <table style={{ width: '100%', tableLayout: 'fixed' }}>
                                    <thead>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Cabys</th>
                                            <th>Impuesto</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {cabysData.map((item) => (
                                            <tr key={item.codigo}>
                                                <td>{item.descripcion}</td>
                                                <td>{item.codigo}</td>
                                                <td>{item.impuesto}%</td>
                                                <td>
                                                    <button onClick={() => handleButtonClick(item.codigo)}>Aplicar</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Modal>
                    )}



                </div>
            </div>
        </div>)
    }
    else {
        return (<><p>Cargando Ficha Catálogo...</p></>)
    }
}
export default FichaCatalogo